// Import de funcions auxiliars
import {
    obteVariable,
    obteValorVariable,
    afegeixErrorAVariable
}  from './utils';

/*
 * Per facilitar la lectura del codi s'afegeixen els identificadors de variables a mode de constants
 ***/
export const ID_COBERTURA_TOTAL_DE_NUVOLS = 45;
export const ID_CLASSE_DE_NUVOLS = 46;
export const ID_COBERTURA_DE_NUVOLS_BAIXOS = 47;
export const ID_CLASSE_DE_NUVOLS_BAIXOS = 48;

// Relació d'etiqueta amb valor de la variable 'Cobertura total de núvols'
const etiquetesValorsCoberturaTotalDeNuvols  = {
    '58': 0,
    '59': 1,
    '60': 2,
    '61': 3,
    '62': 4,
    '63': 5,
    '64': 6,
    '65': 7,
    '66': 8,
};

//El valor 58 de la variable cobertura total de núvols està associat a l'etiqueta "0" a la BBDD
export const VALOR_COBERTURA_TOTAL_DE_NUVOLS_AMB_ETIQUETA_0 = Object.keys(etiquetesValorsCoberturaTotalDeNuvols)[0];
//El valor 61 de la variable cobertura total de núvols està associat a l'etiqueta "3" a la BBDD
export const VALOR_COBERTURA_TOTAL_DE_NUVOLS_AMB_ETIQUETA_3 = Object.keys(etiquetesValorsCoberturaTotalDeNuvols)[3];

// Relació d'etiqueta amb valor de la variable 'Cobertura de núvols baixos'
const etiquetesValorsCoberturaNuvolsBaixos  = {
    '78': 0,
    '79': 1,
    '80': 2,
    '81': 3,
    '82': 4,
    '83': 5,
    '84': 6,
    '85': 7,
    '86': 8,
};

//El valor 78 de la variable cobertura de núvols baixos està associat a l'etiqueta "0" a la BBDD
export const VALOR_COBERTURA_DE_NUVOLS_BAIXOS_AMB_ETIQUETA_0 = Object.keys(etiquetesValorsCoberturaNuvolsBaixos)[0];
//El valor 81 de la variable cobertura de núvols baixos està associat a l'etiqueta "3" a la BBDD
export const VALOR_COBERTURA_DE_NUVOLS_BAIXOS_AMB_ETIQUETA_3 = Object.keys(etiquetesValorsCoberturaNuvolsBaixos)[3];

/*
 * Missatges d'error propis del grup
 ***/
export const MSG_COBERTURA_TOTAL_DE_NUVOLS_OBLIGATORIA = 'La cobertura total de núvols és obligatòria.';
export const MSG_COBERTURA_TOTAL_DE_NUVOLS_SUPERIOR_O_IGUAL_COBERTURA_DE_NUVOLS_BAIXOS = 'La cobertura total de núvols ha de ser superior o igual a la cobertura de núvols baixos.';
export const MSG_SI_COBERTURA_TOTAL_DE_NUVOLS_ES_SUPERIOR_A_0_ALESHORES_CLASSE_DE_NUVOLS_INFORMAT = 'Si la cobertura total de núvols és superior a "0", s\'ha d\'informar la classe de núvols.';
export const MSG_SI_CLASSE_DE_NUVOLS_INFORMAT_ALESHORES_COBERTURA_TOTAL_DE_NUVOLS_SUPERIOR_A_0 = 'Si s\'ha informat la classe de núvols, la cobertura total de núvols ha de ser superior a "0"';
export const MSG_SI_COBERTURA_DE_NUVOLS_BAIXOS_ES_SUPERIOR_A_0_ALESHORES_CLASSE_DE_NUVOLS_BAIXOS_INFORMAT = 'Si la cobertura de núvols baixos és superior a "0", s\'ha d\'informar la classe de núvols baixos.';
export const MSG_SI_CLASSE_DE_NUVOLS_BAIXOS_INFORMAT_ALESHORES_COBERTURA_DE_NUVOLS_BAIXOS_SUPERIOR_A_0 = 'Si s\'ha informat la classe de núvols baixos, la cobertura de núvols baixos ha de ser superior a "0"';

/*
 * Funcions auxiliars que ajuden a la legibilitat
 ***/
const checkCoberturaTotalDeNuvolsObligatoria = (coberturaTotalDeNuvolsValor) => {
    return !coberturaTotalDeNuvolsValor;
};

const checkCoberturaTotalDeNuvolsIgualOSuperiorCoberturaDeNuvolsBaixos = (coberturaTotalDeNuvolsValor, coberturaDeNuvolsBaixosValor) => {
    const etiquetaCorresponentAlValorDeCoberturaTotalDeNuvols = etiquetesValorsCoberturaTotalDeNuvols[coberturaTotalDeNuvolsValor];
    const etiquetaCorresponentAlValorDeCoberturaDeNuvolsBaixos = etiquetesValorsCoberturaNuvolsBaixos[coberturaDeNuvolsBaixosValor];
    return coberturaTotalDeNuvolsValor !== null && coberturaDeNuvolsBaixosValor !== null &&
        etiquetaCorresponentAlValorDeCoberturaTotalDeNuvols < etiquetaCorresponentAlValorDeCoberturaDeNuvolsBaixos;
};

const checkSiCoberturaTotalDeNuvolsEsSuperiorA0ClasseDeNuvolsInformat = (coberturaTotalDeNuvolsValor, classeDeNuvolsValor) => {
    return coberturaTotalDeNuvolsValor !== null &&
           coberturaTotalDeNuvolsValor !== VALOR_COBERTURA_TOTAL_DE_NUVOLS_AMB_ETIQUETA_0 &&
           (classeDeNuvolsValor === null || classeDeNuvolsValor.length === 0);
};

const checkSiClasseDeNuvolsInformatAleshoresCoberturaTotalDeNuvolsEsSuperiorA0 = (coberturaTotalDeNuvolsValor, classeDeNuvolsValor) => {
    return (coberturaTotalDeNuvolsValor === null || coberturaTotalDeNuvolsValor === VALOR_COBERTURA_TOTAL_DE_NUVOLS_AMB_ETIQUETA_0) &&
           classeDeNuvolsValor !== null && classeDeNuvolsValor.length > 0;
};

const checkSiCoberturaDeNuvolsBaixosEsSuperiorA0AleshoresClasseDeNuvolsBaixosInformat = (coberturaDeNuvolsBaixosValor, classeDeNuvolsBaixosValor) => {
    return coberturaDeNuvolsBaixosValor !== null &&
           coberturaDeNuvolsBaixosValor !== VALOR_COBERTURA_DE_NUVOLS_BAIXOS_AMB_ETIQUETA_0 &&
           (classeDeNuvolsBaixosValor === null || classeDeNuvolsBaixosValor.length === 0);
};

const checkSiClasseDeNuvolsBaixosInformatAleshoresCoberturaDeNuvolsBaixosEsSuperiorA0 = (coberturaDeNuvolsBaixosValor, classeDeNuvolsBaixosValor) => {
    return (coberturaDeNuvolsBaixosValor === null || coberturaDeNuvolsBaixosValor === VALOR_COBERTURA_DE_NUVOLS_BAIXOS_AMB_ETIQUETA_0) &&
           classeDeNuvolsBaixosValor !== null && classeDeNuvolsBaixosValor.length > 0;
};

/*
 * Grup Cel
 ***/
export const checkGrupCel = (nouVariables) => {

    // Variables
    const coberturaTotalDeNuvols = obteVariable(ID_COBERTURA_TOTAL_DE_NUVOLS, nouVariables);
    const classeDeNuvols = obteVariable(ID_CLASSE_DE_NUVOLS, nouVariables);
    const coberturaDeNuvolsBaixos = obteVariable(ID_COBERTURA_DE_NUVOLS_BAIXOS, nouVariables);
    const classeDeNuvolsBaixos = obteVariable(ID_CLASSE_DE_NUVOLS_BAIXOS, nouVariables);

    if (coberturaTotalDeNuvols) {
        const coberturaTotalDeNuvolsValor = obteValorVariable(coberturaTotalDeNuvols);

        // La cobertura total de núvols és obligatoria.
        if (checkCoberturaTotalDeNuvolsObligatoria(coberturaTotalDeNuvolsValor)) {
            afegeixErrorAVariable(coberturaTotalDeNuvols, MSG_COBERTURA_TOTAL_DE_NUVOLS_OBLIGATORIA);
        }

        if (classeDeNuvols) {
            const classeDeNuvolsValor = obteValorVariable(classeDeNuvols);

            // Si la cobertura total de núvols és superior a "0" aleshores tipus de classe de núvols informat.
            if (checkSiCoberturaTotalDeNuvolsEsSuperiorA0ClasseDeNuvolsInformat(coberturaTotalDeNuvolsValor, classeDeNuvolsValor)) {
                afegeixErrorAVariable(coberturaTotalDeNuvols, MSG_SI_COBERTURA_TOTAL_DE_NUVOLS_ES_SUPERIOR_A_0_ALESHORES_CLASSE_DE_NUVOLS_INFORMAT);
                afegeixErrorAVariable(classeDeNuvols, MSG_SI_COBERTURA_TOTAL_DE_NUVOLS_ES_SUPERIOR_A_0_ALESHORES_CLASSE_DE_NUVOLS_INFORMAT);
            }

            // Si tipus de classe de núvols informat, la cobertura total de núvols ha de ser superior a "0"
            if (checkSiClasseDeNuvolsInformatAleshoresCoberturaTotalDeNuvolsEsSuperiorA0(coberturaTotalDeNuvolsValor, classeDeNuvolsValor)) {
                afegeixErrorAVariable(coberturaTotalDeNuvols, MSG_SI_CLASSE_DE_NUVOLS_INFORMAT_ALESHORES_COBERTURA_TOTAL_DE_NUVOLS_SUPERIOR_A_0);
                afegeixErrorAVariable(classeDeNuvols, MSG_SI_CLASSE_DE_NUVOLS_INFORMAT_ALESHORES_COBERTURA_TOTAL_DE_NUVOLS_SUPERIOR_A_0);
            }
        }

        if (coberturaDeNuvolsBaixos) {
            const coberturaDeNuvolsBaixosValor = obteValorVariable(coberturaDeNuvolsBaixos);

            // La cobertura total de núvols ha de ser igual o superior la cobertura de núvols baixos.
            if (checkCoberturaTotalDeNuvolsIgualOSuperiorCoberturaDeNuvolsBaixos(coberturaTotalDeNuvolsValor, coberturaDeNuvolsBaixosValor)) {
                afegeixErrorAVariable(coberturaTotalDeNuvols, MSG_COBERTURA_TOTAL_DE_NUVOLS_SUPERIOR_O_IGUAL_COBERTURA_DE_NUVOLS_BAIXOS);
                afegeixErrorAVariable(coberturaDeNuvolsBaixos, MSG_COBERTURA_TOTAL_DE_NUVOLS_SUPERIOR_O_IGUAL_COBERTURA_DE_NUVOLS_BAIXOS);
            }
        }
    }

    if (classeDeNuvolsBaixos && coberturaDeNuvolsBaixos) {
        const coberturaDeNuvolsBaixosValor = obteValorVariable(coberturaDeNuvolsBaixos);
        const classeDeNuvolsBaixosValor = obteValorVariable(classeDeNuvolsBaixos);

        // Si la cobertura de núvols baixos és superior a "0" aleshores tipus de classe de núvols informat.
        if (checkSiCoberturaDeNuvolsBaixosEsSuperiorA0AleshoresClasseDeNuvolsBaixosInformat(coberturaDeNuvolsBaixosValor, classeDeNuvolsBaixosValor)) {
            afegeixErrorAVariable(coberturaDeNuvolsBaixos, MSG_SI_COBERTURA_DE_NUVOLS_BAIXOS_ES_SUPERIOR_A_0_ALESHORES_CLASSE_DE_NUVOLS_BAIXOS_INFORMAT);
            afegeixErrorAVariable(classeDeNuvolsBaixos, MSG_SI_COBERTURA_DE_NUVOLS_BAIXOS_ES_SUPERIOR_A_0_ALESHORES_CLASSE_DE_NUVOLS_BAIXOS_INFORMAT);
        }

        // Si tipus de classe de núvols informat, la cobertura total de núvols ha de ser superior a "0"
        if (checkSiClasseDeNuvolsBaixosInformatAleshoresCoberturaDeNuvolsBaixosEsSuperiorA0(coberturaDeNuvolsBaixosValor, classeDeNuvolsBaixosValor)) {
            afegeixErrorAVariable(coberturaDeNuvolsBaixos, MSG_SI_CLASSE_DE_NUVOLS_BAIXOS_INFORMAT_ALESHORES_COBERTURA_DE_NUVOLS_BAIXOS_SUPERIOR_A_0);
            afegeixErrorAVariable(classeDeNuvolsBaixos, MSG_SI_CLASSE_DE_NUVOLS_BAIXOS_INFORMAT_ALESHORES_COBERTURA_DE_NUVOLS_BAIXOS_SUPERIOR_A_0);
        }
    }
};



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/filtresCoherencia/grupCel.js